import * as React from 'react'
import { pipe } from 'fp-ts/lib/function'
import { Tag, Typography } from 'antd'
import { array } from 'fp-ts'
import { AssignableKeys, requiredKeys } from './types'
import { messageLookups } from './shared'
import { FormattedMessage } from 'react-intl'
import { useMode } from '../Bills/queries'

type Props = {
  assignments: Record<AssignableKeys, string>
}

const MissingTags = ({ assignments }: Props) => {
  const mode = useMode()
  const missingKeys = React.useMemo(
    () =>
      pipe(
        requiredKeys(mode),
        array.filter(k => !assignments[k] || assignments[k] === '')
      ),
    [mode, assignments]
  )

  return (
    <>
      <Typography.Paragraph>
        {array.isEmpty(missingKeys) ? (
          <FormattedMessage id="allDone" />
        ) : (
          <FormattedMessage id="assignMissingColumns" />
        )}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {pipe(
          missingKeys,
          array.map(v => (
            <Tag color="red" key={v}>
              {messageLookups[v]}
            </Tag>
          ))
        )}
      </Typography.Paragraph>
    </>
  )
}

export default MissingTags
